/* Charles Medical — touch handling for the desktop nav bar.

   custom-async.js binds the mouseover handlers that open a dropdown only
   when `!isMobile` (custom.js:43 treats any touch-capable device as mobile),
   so on a tablet the top-level links navigate on the first tap and the
   submenus are unreachable. This makes the first tap open the dropdown and
   the second tap follow the link.

   Only runs on touch devices at >=1001px. Below that #nav is the mobile
   drawer, which already has its own per-item toggle controls. */

(function () {
	'use strict';

	var nav = document.getElementById('nav');
	if (!nav) return;

	var isTouch = window.matchMedia('(pointer: coarse)').matches ||
		'ontouchstart' in window ||
		navigator.maxTouchPoints > 0;
	if (!isTouch) return;

	var isDesktop = window.matchMedia('(min-width: 1001px)');

	// The link waiting for its second tap.
	var armed = null;

	var TOP_LINK = '#nav > ul > li.menu-has-submenu > a';

	/* The panel is shown only by real :hover -- async-menu.css:14 sets
	   display:none and async-hovers.css:53 flips it to display:flex on
	   `li:hover`. Touch never produces :hover, so the theme's .hover class
	   alone leaves the panel hidden.

	   We can't hang a display rule on .hover either: custom-async.js never
	   clears it on mouseleave (only html.nav-hover), so mouse users would be
	   left with panels stuck open. `cm-open` is added and removed here and
	   nowhere else, so it stays in step with the taps. */
	function openItem(li) {
		var siblings = li.parentElement.children;
		for (var i = 0; i < siblings.length; i++) {
			siblings[i].classList.remove('cm-open');
		}

		// The theme's own routine also sets aria-expanded and the data-items
		// count the mega panel uses for its column layout.
		if (typeof navSubHover === 'function') {
			navSubHover(li);
		} else {
			for (var j = 0; j < siblings.length; j++) {
				siblings[j].classList.remove('hover');
				siblings[j].setAttribute('aria-expanded', 'false');
			}
			li.classList.add('hover');
			li.setAttribute('aria-expanded', 'true');
			document.documentElement.classList.add('nav-hover');
		}

		li.classList.add('cm-open');
	}

	function closeAll() {
		var open = document.querySelectorAll('#nav > ul > li.hover, #nav > ul > li.cm-open');
		for (var i = 0; i < open.length; i++) {
			open[i].classList.remove('hover');
			open[i].classList.remove('cm-open');
			open[i].setAttribute('aria-expanded', 'false');
		}
		document.documentElement.classList.remove('nav-hover');
	}

	nav.addEventListener('click', function (event) {
		if (!isDesktop.matches) return;

		/* The "..." overflow pill. Its panel is hidden by the same :hover-only
		   rule as the other dropdowns, so touch needs cm-open here too.
		   Matched on the <li>, not the <a>: async-hovers.css:243 sets
		   pointer-events:none on that anchor, so the click lands on the item.
		   It's a pure toggle -- there is nowhere to navigate to. */
		var pill = event.target.closest('#nav > ul > li.show-all');
		if (pill) {
			event.preventDefault();
			var wasOpen = pill.classList.contains('cm-open');
			closeAll();
			armed = null;
			if (!wasOpen) {
				pill.classList.add('cm-open');
				document.documentElement.classList.add('nav-hover');
			}
			return;
		}

		var link = event.target.closest(TOP_LINK);
		if (!link) return;

		// a.toggle is the hidden 44px submenu control and a.toggle-wide is the
		// View catalog button; both are handled by the theme's own delegation.
		if (link.classList.contains('toggle') || link.classList.contains('toggle-wide')) return;

		// Second tap on the same link — let the browser navigate.
		if (link === armed) {
			armed = null;
			return;
		}

		event.preventDefault();
		armed = link;
		openItem(link.parentElement);
	});

	// Tapping anywhere outside an open item closes it and disarms.
	document.addEventListener('click', function (event) {
		if (event.target.closest('#nav > ul > li.menu-has-submenu, #nav > ul > li.show-all')) return;
		armed = null;
		closeAll();
	});

	// Leaving the desktop breakpoint hands control back to the drawer.
	isDesktop.addEventListener('change', function () {
		armed = null;
	});
})();
